import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useBulkAssignLeads = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await supabase.rpc('bulk_assign_unassigned_leads');

      if (error) throw error;
      return data;
    },
    onSuccess: (data) => {
      if (data && data.length > 0) {
        const result = data[0];
        const count = result?.assigned_count || 0;

        if (count > 0) {
          toast.success(`${count} lead${count > 1 ? 's foram atribuídos' : ' foi atribuído'} com sucesso!`);
        } else {
          toast.info('Nenhum lead pendente de atribuição encontrado.');
        }

        // Invalida a query dos leads para recarregar
        queryClient.invalidateQueries({ queryKey: ['leads'] });
      }
    },
    onError: (error: Error) => {
      console.error('Erro ao atribuir leads:', error);
      toast.error('Erro ao atribuir leads em massa: ' + error.message);
    },
  });
};
